const SvgIcon = ({ size = '24', color = '#444247' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      strokeWidth="1"
      d="M8.052 6.848 10.8 4.087v11.51a1.2 1.2 0 1 0 2.4 0V4.088l2.748 2.76a1.2 1.2 0 0 0 1.704 0 1.2 1.2 0 0 0 0-1.704l-4.8-4.8a1.2 1.2 0 0 0-.396-.253 1.2 1.2 0 0 0-.912 0 1.2 1.2 0 0 0-.396.252l-4.8 4.801a1.205 1.205 0 0 0 1.704 1.705m14.748 7.55a1.2 1.2 0 0 0-1.2 1.2v4.801a1.2 1.2 0 0 1-1.2 1.2H3.6a1.2 1.2 0 0 1-1.2-1.2v-4.801a1.2 1.2 0 1 0-2.4 0v4.801A3.6 3.6 0 0 0 3.6 24h16.8a3.6 3.6 0 0 0 3.6-3.6v-4.802a1.2 1.2 0 0 0-1.2-1.2"
    ></path>
  </svg>
);

export default SvgIcon;
